//API Suffix required for running jss locally
export const ApiPrefix =
  process.env.NODE_ENV === 'production' ? '/formsapi/v1' : 'https://racqformscm.localhost/formsapi/v1';

export const FormUrlBase =
  process.env.NODE_ENV === 'production'
    ? 'https://#{racq.website.cd.form.hostname}/insurance/quote'
    : '/insurance/quote';

//login url's
export const authenticationUrl = `${ApiPrefix}/login/authenticate`;
export const isAuthenticatedUrl = `${ApiPrefix}/login/isauthenticated`;
export const logoutUrl = `${ApiPrefix}/login/logout`;
export const revokeLoginUrl = 'https://graph.microsoft.com/v1.0/me/revokeSignInSessions';

// api's for assistance product
export const getAssistanceProduct = `${ApiPrefix}/assistance/getassistanceproduct?policyId={0}`;
export const setAssistanceAutoRenewFlag = `${ApiPrefix}/assistance/setautoRenewflag?policyId={0}`;
export const isEligibilityForCancellation = `${ApiPrefix}/assistance/iseligibilityforcancellation?policyId={0}`;

// api's for insurance products
export const getInsuranceProduct = `${ApiPrefix}/insurance/getinsuranceproduct?policyNumber={0}`;
export const isInsuranceEligibleForCancellation = `${ApiPrefix}/insurance/IsEligibleForCancellation?policyNumber={0}`;
export const isCancellationDateEligible = `${ApiPrefix}/insurance/iscancellationdateeligible`;
export const cancelInsurance = `${ApiPrefix}/insurance/cancelinsurance`;
export const getInsurancePoliciesUrl = `${ApiPrefix}/insurance/getinsurancepolicies`;

export const getIncompleteClaims = `${ApiPrefix}/insurance/getIncompleteClaims`;
export const getInProgressClaims = `${ApiPrefix}/insurance/getInProgressClaims`;
export const getInsurancePolicyRenewal = `${ApiPrefix}/insurance/getInsurancePolicyRenewal?policyNumber={0}`;
export const initializeAvokaForm = `${ApiPrefix}/insurance/initializeAvokaForm`;
export const getInsurancePolicyCurrent = `${ApiPrefix}/insurance/getinsurancepolicycurrent?policynumber={0}`;

// api's for roadside assistance
export const cancelRoadsideAssistanceJob = `${ApiPrefix}/roadsideassistance/CancelJob`;
export const getServiceabilityRoadsideAssistanceJob = `${ApiPrefix}/roadsideassistance/GetServiceAbility?latitude={0}&longitude={1}`;
export const matchPartyRoadsideAssistance = `${ApiPrefix}/roadsideassistance/MatchParty`;
export const postCreateRsaJobJoinOnRoad = `${ApiPrefix}/roadsideassistance/CreateJobJoinOnRoad`;
export const getCheckEligibility = `${ApiPrefix}/roadsideassistance/CheckEligibility?vehicleRegistration={0}&d365Id={1}&membershipCardNumber={2}`;
export const postCreateRsaJobHtml = `${ApiPrefix}/roadsideassistance/CreateJobHtml`;
export const postCreateRsaFleetJobHtml = `${ApiPrefix}/roadsideassistance/CreateFleetJobHtml`;
export const isTrackableUrl = `${ApiPrefix}/roadsideassistance/IsTrackable?dispatchGroup={0}`;
export const getShouldJeopardy = `${ApiPrefix}/roadsideassistance/ShouldJeopardy?policyStatus={0}`;
export const postCreateParty = `${ApiPrefix}/roadsideassistance/CreateParty`;
export const postCreateQuote = `${ApiPrefix}/roadsideassistance/CreateQuote`;
export const postFinaliseQuote = `${ApiPrefix}/roadsideassistance/FinaliseQuote?apttusQuoteId={0}&apttusCartId={1}`;
export const postRsaSubmitPurchase = `${ApiPrefix}/roadsideassistance/SubmitPurchase`;
export const postSendRoadsideGenericInvoiceEmail = `${ApiPrefix}/roadsideassistance/SendGenericInvoiceEmail`;
export const postRsaSendUpgradeRoadsideEmail = `${ApiPrefix}/roadsideassistance/SendUpgradeRoadsideEmail`;
export const getHasExistingPolicyForRego = `${ApiPrefix}/roadsideassistance/HasExistingPolicyForRego?apttusId={0}&vehicleRegistration={1}`;
export const getEligibleProductForUpgrade = `${ApiPrefix}/roadsideassistance/GetEligibleProductForUpgrade?apttusId={0}&policyId={1}`;
export const postUpgradeRoadsideVehicle = `${ApiPrefix}/roadsideassistance/UpgradeRoadsideVehicle`;
export const getUpgradeQuotes = `${ApiPrefix}/roadsideassistance/getupgradequotes?apttusId={0}&productCode={1}&policyPrice={2}&assetLineItemId={3}`;
export const changeRegoUrl = `${ApiPrefix}/roadsideassistance/changeregistrationnumber?newRego={0}&policyId={1}`;
export const getFleetServiceByRegoAndServiceNumber = `${ApiPrefix}/roadsideassistance/FleetGetByRegoAndServiceNumber?rego={0}`;
export const postGetMemberContactDetails = `${ApiPrefix}/roadsideassistance/GetMemberContactDetails`;
export const postSendMembershipCardNumber = `${ApiPrefix}/roadsideassistance/SendMembershipCardNumber`;

// api's for insurance quote session
export const getQuoteSessionId = `${ApiPrefix}/quotesessionv2/getquotesessionid?policyNumber={0}&quoteSessionType={1}`;
export const getQuoteSessionIdByCoverage = `${ApiPrefix}/quotesessionv2/getquotesessionidbycoverage?policyNumber={0}&quoteSessionType={1}&coverageId={2}`;
export const bindQuoteSessionUrl = `${ApiPrefix}/quotesessionv2/BindQuoteSession?quoteSessionId={0}`;
export const quoteSessionProcessPaymentUrl = `${ApiPrefix}/quotesessionv2/ProcessPayment?policyNumber={0}&quoteSessionId={1}`;
export const withdrawQuoteSessionUrl = `${ApiPrefix}/quotesessionv2/WithdrawQuoteSession?quoteSessionId={0}`;
export const getQuoteSession = `${ApiPrefix}/quotesessionv2/getquotesession?quoteSessionId={0}`;
export const deleteQuoteSession = `${ApiPrefix}/quotesessionv2/deletequotesession?quoteSessionId={0}`;
export const refreshQuoteSession = `${ApiPrefix}/quotesessionv2/refreshquotesession`;
export const createQuoteSession = `${ApiPrefix}/quotesessionv2/createquotesession`;

// api's for profile data
export const getIdentityDetails = `${ApiPrefix}/identity/getidentitydetails`;
export const checkUpdatePostalAddressRequired = `${ApiPrefix}/identity/CheckUpdatePostalAddressRequired?partyId={0}&dpid={1}`;
export const getLoyaltyType = `${ApiPrefix}/identity/GetLoyaltyType`;
export const getResidentialAddress = `${ApiPrefix}/identity/GetResidentialAddress`;
export const getPostalAddress = `${ApiPrefix}/identity/GetPostalAddress`;
export const putUpdatePostalAddress = `${ApiPrefix}/identity/updatepostaladdress?d365Id={0}`;
export const getMembershipCardNumber = `${ApiPrefix}/identity/GetMemberCardNumber`;
export const downloadAppleMembershipCard = `${ApiPrefix}/membershipcardapi/DownloadAppleMembershipCard`;
export const downloadGoogleMembershipCard = `${ApiPrefix}/membershipcardapi/DownloadGoogleMembershipCard`;
export const getMemberNumber = `${ApiPrefix}/membershipcardapi/GetConvertedMemberNumber`;
export const updateContactInformation = `${ApiPrefix}/identity/updatecontactinformation`;
export const searchIdentitiesUrl = `${ApiPrefix}/identity/searchidentity`;
export const updateAddressInformation = `${ApiPrefix}/identity/updateaddressinformation`;
export const isUserNameTaken = `${ApiPrefix}/identity/isusernametaken?email={0}`;
export const checkIsMissingResidentialAddressUrl = `${ApiPrefix}/identity/checkIsMissingResidentialAddress?partyId={0}`;

//api for direct debit profile data
export const getPortfolioAssitanceProductsForDirectDebit = `${ApiPrefix}/identity/GetPortfolioAssitanceProductsForDirectDebit`;

// api's for reference data
export const getNumOfStoreys = `${ApiPrefix}/refdata/getnumofstoreys?buildingType={0}`;
export const getLowestOccupiedFloor = `${ApiPrefix}/refdata/getlowestoccupiedfloor?buildingType={0}`;
export const getPrimaryConstructionMaterials = `${ApiPrefix}/refdata/getprimaryconstructionmaterials?quoteType={0}`;
export const getRoofTypeMaterials = `${ApiPrefix}/refdata/getrooftypematerials?quoteType={0}`;
export const getBuildingTypes = `${ApiPrefix}/refdata/getbuildingtypes`;
export const getPersonTitles = `${ApiPrefix}/refdata/getPersonTitles`;
export const getGenders = `${ApiPrefix}/refdata/getGenders`;
export const getPetTypes = `${ApiPrefix}/refdata/getPetTypes?quoteType={0}`;
export const getPetBreeds = `${ApiPrefix}/refdata/getPetBreeds?quoteType={0}&petType={1}`;
export const fetchHomeClaimTypes = `${ApiPrefix}/refdata/getHomeClaimTypes?quoteType={0}`;
export const fetchHomeLossTypes = `${ApiPrefix}/refdata/getHomeLossTypes?quoteType={0}`;
export const fetchHomeLossValues = `${ApiPrefix}/refdata/getHomeLossValues?quoteType={0}`;
export const getHomeAdvancedCover = `${ApiPrefix}/refdata/getHomeAdvancedOptions?quoteType={0}&occupancyType={1}`;
export const getHomeOccupancyTypes = `${ApiPrefix}/refdata/getHomeOccupancyTypes`;
export const getHomeFloorOccupancy = `${ApiPrefix}/refdata/getHomeFloorOccupancy?buildingType={0}`;
export const getHomeGroupCoverPriceBands = `${ApiPrefix}/refdata/getGroupCoverPriceBands?quoteType={0}`;
export const getPortableItemCategories = `${ApiPrefix}/refdata/getPortableItemCategories?quoteType={0}`;
export const getHomeItemCategories = `${ApiPrefix}/refdata/getHomeItemCategories?quoteType={0}&withPolicyUpdate={1}`;
export const getSmallBusinessInsuranceLimitValue = `${ApiPrefix}/refdata/getSmallBusinessInsuranceLimitValue?quoteType={0}`;
export const getEarthquakeExcesses = `${ApiPrefix}/refdata/getEarthquakeExcesses?quoteType={0}`;
export const getPetExcesses = `${ApiPrefix}/refdata/getPetExcesses?quoteType={0}&occupancyType={1}`;
export const getPetExcessOptions = `${ApiPrefix}/refdata/getPetExcessOptions?quoteType={0}`;
export const getPortableExcesses = `${ApiPrefix}/refdata/getPortableExcesses?quoteType={0}`;
export const getPortableMobileExcesses = `${ApiPrefix}/refdata/getPortableMobileExcesses?quoteType={0}`;
export const getMotorExcessesUrl = `${ApiPrefix}/refdata/GetExcess?quoteType={0}&effectiveDate={1}`;
export const getDriverLicenseIssueTypes = `${ApiPrefix}/refdata/getDriverLicenseIssueTypes`;
export const getCancellationHistoryUrl = `${ApiPrefix}/refdata/GetDriverLicenseHistoryTypes`;
export const getAtFaultClaimValues = `${ApiPrefix}/refdata/GetAtFaultClaimValues`;
export const getAtFaultClaimTypes = `${ApiPrefix}/refdata/GetAtFaultClaimTypes`;
export const getFrameMaterials = `${ApiPrefix}/refdata/getFrameMaterials?quoteType={0}`;
export const getFloorMaterials = `${ApiPrefix}/refdata/getFloorMaterials?quoteType={0}`;
export const getMonitoredAlarmTypes = `${ApiPrefix}/refdata/getMonitoredAlarmTypes?quoteType={0}`;
export const getHomeAndContentProducts = `${ApiPrefix}/refdata/GetHomeAndContentProducts?occupancyType={0}&buildingType={1}`;
export const getHomeAndContentBuildingPropertyFeatures = `${ApiPrefix}/refdata/getBuildingPropertyFeatures`;
export const getHomeAndContentsGroupCoverPriceBands = `${ApiPrefix}/refdata/GetGroupCoverPriceBands?quoteType={0}`;
export const getInsuranceProducts = `${ApiPrefix}/refdata/getInsuranceProducts`;
export const getMembershipLevels = `${ApiPrefix}/refdata/getMembershipLevels?quoteType={0}`;
export const getQuotingFeesPayByMonth = `${ApiPrefix}/refdata/getQuotingFeesByMonth?effectiveDate={0}`;
export const getParkingLocationsUrl = `${ApiPrefix}/refdata/getparkinglocations`;
export const getVehicleBusinessUseTypesListUrl = `${ApiPrefix}/refdata/getVehicleBusinessUseTypes`;
export const getFinanceTypesUrl = `${ApiPrefix}/refdata/getfinancetypes`;
export const getDriverRatingsUrl = `${ApiPrefix}/refdata/GetDriverRatings`;
export const getDriverLicenseYearsHeldRangesUrl = `${ApiPrefix}/refdata/GetDriverLicenseYearsHeldRanges`;
export const getYearsRatingOneHeldUrl = `${ApiPrefix}/refdata/GetYearsRatingOneHeld`;
export const getHomeExcessValues = `${ApiPrefix}/refdata/getHomeExcessValues`;
export const getContentsExcessValues = `${ApiPrefix}/refdata/getContentsExcessValues`;
export const getAdvancedCoverValues = `${ApiPrefix}/refdata/GetAdvancedCoverValues?quoteType={0}&occupancyType={1}`;
export const getPetCover = `${ApiPrefix}/refdata/GetPetCover?quoteType={0}&occupancyType={1}`;
export const getVehicleAgreedValueRangeUrl = `${ApiPrefix}/refdata/GetVehicleAgreedValueRange?quoteType={0}&marketValue={1}`;
export const getBusinessUseWarningEnable = `${ApiPrefix}/refdata/IsBusinessUseWarningEnabled?policyStartDate={0}`;
export const getSuburbsEmbargo = `${ApiPrefix}/refdata/getSuburbsEmbargo?postCode={0}&suburb={1}&gnaf={2}&state={3}&policyLine={4}&vehicleType={5}
            &jobType={6}&coveragePatternCode={7}&effectiveDate={8}&writtenDate={9}`;

//common services
export const getFinancialInstitutionFromBsb = `${ApiPrefix}/payment/getfinancialinstitutionfrombsb?bsb={0}`;
export const getPaymentConfiguration = `${ApiPrefix}/paymentgateway/getpaymentconfiguration`;
export const getApttusDirectDebitStatus = `${ApiPrefix}/payment/GetApttusDirectDebitStatus?apttusId={0}`;

// Apple Pay (proxy endpoints in Forms API)
export const postApplePayMerchantSession = `${ApiPrefix}/payment/applepaysession`;
export const postApplePayPayWithApple = `${ApiPrefix}/payment/paywithapple`;
export const getPaymentDetails = `${ApiPrefix}/insurance/GetPaymentInstrument?policyNumber={0}&currentTerm={1}`;

// api's for renewal offer data
export const getRenewalPolicyDetails = `${ApiPrefix}/insurance/getRenewalPolicyDetails?policyId={0}`;
export const setRenewalOfferPreference = `${ApiPrefix}/insurance/setRenewalOffer`;
export const sendRenewalReceiptEmail = `${ApiPrefix}/insurance/sendRenewalReceiptEmail`;
export const reinstatePolicy = `${ApiPrefix}/insurance/reinstatePolicy?policyNumber={0}`;

// api's for add to cover form
export const addToCoverGetQuoteSessionId = `${ApiPrefix}/addtocover/GetQuoteSessionId?policyNumber={0}`;
export const addToCoverUpdateCoveragePricing = `${ApiPrefix}/addtocover/UpdateCoveragePricing?quoteSessionId={0}`;
export const addToCoverGetPolicyRenewal = `${ApiPrefix}/addtocover/GetPolicyRenewal?policyNumber={0}`;
export const addToCoverSubmitChanges = `${ApiPrefix}/addtocover/SubmitChanges`;

// api's for update cyclone form
export const updateFloodCycloneDetails = `${ApiPrefix}/homeinsurance/updatefloodcyclonedetails?quoteSessionId={0}`;

// callback form api
export const submitCallBackDetails = `${ApiPrefix}/callback/submitcallbackform?policyid={0}`;

// autoglass form api
export const submitAutoGlassFormDetails = `${ApiPrefix}/autoglass/submitautoglassform`;

export const isProduction = process.env.NODE_ENV === 'production';
export const localURL = 'http://localhost:3001';

export const getLiveChatSessionData = `${ApiPrefix}/livechatapi/getsessiondata`;

export const getSelfServiceAccountOverviewUrl = `${ApiPrefix}/configuration/getselfserviceaccountoveriewpage`;
export const getSelfServiceChangeVehicleUrl = `${ApiPrefix}/configuration/getselfservicechangevehiclepage?isinsuranceproduct={0}`;
export const getSelfServiceMakePaymentUrl = `${ApiPrefix}/configuration/getselfservicemakepaymentpage`;
export const getSelfServiceRoadsideAssistancePageUrl = `${ApiPrefix}/configuration/getselfserviceroadsideassistancepage`;
export const getSelfServiceRSAManagePaymentPageUrl = `${ApiPrefix}/configuration/getselfservicersamanagepaymentpage`;
export const getSelfServiceToggles = `${ApiPrefix}/configuration/getSelfServiceToggles`;

export const getFeatureToggles = `${ApiPrefix}/commonconfiguration/getFeatureToggles`;
export const getIQConfigSettings = `${ApiPrefix}/insurancequoteconfig/getIQConfigSettings`;
export const getCommonConfigSettings = `${ApiPrefix}/configuration/getcommonconfigurationsettings`;

// api's for vehicle lookup
export const getVehicleByRego = `${ApiPrefix}/vehicle/getvehiclebyrego`;
export const getVehiclesByMake = `${ApiPrefix}/vehicle/getmakes`;
export const getVehicleModels = `${ApiPrefix}/vehicle/getmodels`;
export const getVehicleVariants = `${ApiPrefix}/vehicle/getvariants`;
export const getVehicleBodies = `${ApiPrefix}/vehicle/getbodies`;
export const getVehicleDetails = `${ApiPrefix}/vehicle/getvehicledetails`;
export const getVehiclesByNVIC = `${ApiPrefix}/vehicle/getvehiclebynvic`;
export const getVehicleYears = `${ApiPrefix}/vehicle/getvehicleyears`;
export const getCombinedAccessoriesList = `${ApiPrefix}/refdata/getcombinedaccessorieslist`;
export const getVehicleEligibility = `${ApiPrefix}/vehicle/getvehicleeligibility`;

// api for address lookup
export const getSuburbsByPostcode = `${ApiPrefix}/refdata/GetSuburbsByPostcode?postcode={0}&excludePostal={1}`;
export const getInsuranceRiskSuburbs = `${ApiPrefix}/refdata/GetInsuranceRiskSuburbs?query={0}`;
export const getAddressLookupAutocomplete = `${ApiPrefix}/addresslookup/autocomplete?query={0}`;
export const getCountryLookupAutocomplete = `${ApiPrefix}/addresslookup/country?query={0}&allcountries={1}&includeiso={2}`;
export const getAddressLookupFormat = `${ApiPrefix}/addresslookup/format`;
export const getIsCycloneCovered = `${ApiPrefix}/addresslookup/getIsCycloneCovered`;
export const formatRiskAddressUrl = `${ApiPrefix}/addresslookup/format-risk-address`;

// api for get insurance quote
export const getInsuranceQuoteById = `${ApiPrefix}/Quote/GetQuote?sessionId={0}`;
export const postInsuranceQuoteCreateQuote = `${ApiPrefix}/Quote/CreateQuote`;
export const postInsuranceQuoteApplyRules = `${ApiPrefix}/Quote/ApplyRules?quoteId={0}`;
export const postInsuranceQuoteUpdateQuote = `${ApiPrefix}/Quote/UpdateQuote?quoteId={0}`;
export const postInsuranceQuoteCalculatePrice = `${ApiPrefix}/Quote/CalculatePremium?quoteId={0}`;
export const postInsuranceSubmitQuote = `${ApiPrefix}/Quote/SubmitQuote?quoteId={0}`;
export const postInsuranceQuoteSendQuoteEmail = `${ApiPrefix}/Quote/SendQuoteEmail?quoteId={0}`;
export const retrieveInsuranceQuoteUrl = `${ApiPrefix}/Quote/RetrieveQuote?quoteNumber={0}&postcode={1}`;
export const getSessionIdUrl = `${ApiPrefix}/Quote/GetSessionId?quoteId={0}`;

// api for lifestyle form
export const getJoinLifestyleFormInitialContent = `${ApiPrefix}/Lifestyle/GetJoinLifestyleFormInitialContent`;
export const checkLifestyleIsEligible = `${ApiPrefix}/Lifestyle/IsEligible`;
export const postLifestyleSubmitPurchase = `${ApiPrefix}/Lifestyle/SubmitPurchase`;
export const postSendLifestyleGenericInvoiceEmail = `${ApiPrefix}/Lifestyle/SendGenericInvoiceEmail`;

// api for change payment details form
export const changePaymentDetailsFetchPaymentDetails = `${ApiPrefix}/ChangePaymentDetails/FetchPaymentDetails?quoteSessionId={0}`;
export const changePaymentDetailsApplyRulesAndSave = `${ApiPrefix}/ChangePaymentDetails/ApplyRulesAndSave`;

// api for change vehicle location form
export const changeVehicleLocationGetPolicy = `${ApiPrefix}/ChangeVehicleLocation/GetPolicy?quoteSessionId={0}`;
export const changeVehicleLocationApplyBusinessRules = `${ApiPrefix}/ChangeVehicleLocation/ApplyBusinessRules`;

//api for change vehicle registration number (insurance)
export const changeVehicleRegistartionInsurance = `${ApiPrefix}/ChangeVehicle/ChangeVehicleRegistrationNumber`;

// api for decision intelligence
export const postDecisionIntelligenceCreateOffer = `${ApiPrefix}/DecisionIntelligence/CreateOffer`;
export const getDecisionIntelligenceOffer = `${ApiPrefix}/DecisionIntelligence/GetDecisionOffer?decisionOfferId={0}`;
export const acknowlegeDecisionOffer = `${ApiPrefix}/DecisionIntelligence/AcknowledgeOffer?decisionId={0}`;
export const acknowlegeRenewalDecisionOffer = `${ApiPrefix}/DecisionIntelligence/acknowledgerenewaloffer`;

export const createLead = `${ApiPrefix}/DecisionIntelligence/CreateLead?d365Id={0}`;
export const createRsaPrepayOffer = `${ApiPrefix}/DecisionIntelligence/createroadsideprepayrenewaloffer`;
export const getRsaPrepayOffer = `${ApiPrefix}/DecisionIntelligence/getrsaprepayoffer?decisionId={0}`;
export const acknowledgePrepayOffer = `${ApiPrefix}/DecisionIntelligence/acknowledgersaprepayoffer?prn={0}&apttusQuoteId={1}&apttusId={2}`;

//api's for google maps
export const getGoogleMapsApiKey = `${ApiPrefix}/GoogleMaps/getApiKey`;
export const getGoogleMapsMapId = `${ApiPrefix}/GoogleMaps/getMapId`;
export const getGoogleMapsDefaultZoomLevel = `${ApiPrefix}/GoogleMaps/getDefaultZoomLevel`;
export const getGoogleMapsTipText = `${ApiPrefix}/GoogleMaps/getTipText`;
export const getAllGoogleMapsSettings = `${ApiPrefix}/GoogleMaps/getAllGoogleMapsSettings`;

//api for join on road (JOR) form
export const getJORProducts = `${ApiPrefix}/joinonroad/getproducts`;

// api for payment reference number
export const getPrnDetails = `${ApiPrefix}/payment/getprndetails?prn={0}`;
export const processPrnPayment = `${ApiPrefix}/payment/processpayment`;
export const sendReceiptEmail = `${ApiPrefix}/payment/sendreceiptemail`;
export const applyDiscountToQuote = `${ApiPrefix}/payment/applydiscounttoquote`;
export const addDirectDebitToPrn = `${ApiPrefix}/payment/adddirectdebittoprn?apttusId={0}`;
//api for direct debit
export const setDirectDebitAssetLineItemStatuses = `${ApiPrefix}/payment/updatedirectdebitassetlineitems?apttusId={0}`;
export const updateDirectDebitPaymentMethod = `${ApiPrefix}/payment/updatedirectdebitpayment?apttusId={0}&paymentMethodId={1}`;
export const deactivateDirectDebitPaymentMethod = `${ApiPrefix}/payment/deactivatedirectdebit?apttusId={0}&paymentMethodId={1}`;

// api for change vehicle form
export const changeVehicleGetPolicy = `${ApiPrefix}/ChangeVehicle/GetPolicy?quoteSessionId={0}`;
export const changeVehicleApplyBusinessRules = `${ApiPrefix}/ChangeVehicle/ApplyBusinessRules`;

// api for switch to monthly self service form
export const switchToMonthlyGetPolicy = `${ApiPrefix}/SwitchToMonthly/GetPolicy?quoteSessionId={0}`;
export const switchToMonthlyApplyBusinessRules = `${ApiPrefix}/SwitchToMonthly/ApplyBusinessRules`;

// api for Buy Roadside form
export const getRoadsideProducts = `${ApiPrefix}/buyroadside/getproducts?validFor={0}`;

// api for change vehicle form
export const upgradeMotorGetPolicy = `${ApiPrefix}/UpgradeMotor/GetPolicy?quoteSessionId={0}`;
export const upgradeMotorApplyBusinessRules = `${ApiPrefix}/UpgradeMotor/ApplyBusinessRules`;

//api for defer payment
export const deferPaymentGetPolicy = `${ApiPrefix}/DeferPayment/GetPolicy?quoteSessionId={0}`;
export const deferPaymentApplyBusinessRules = `${ApiPrefix}/DeferPayment/ApplyBusinessRules`;
export const deferPaymentGetMaxDeferPaymentDays = `${ApiPrefix}/DeferPayment/GetMaxDeferPaymentDays`;
export const deferPaymentGetPaymentInstrument = `${ApiPrefix}/DeferPayment/FetchPaymentDetails?quoteSessionId={0}`;

// api for fuel finder
export const findFuelUrl = `${ApiPrefix}/FairFuelFinder/FindFuel?lat={0}&lng={1}&fuelType={2}`;

// api for marketing
export const unsubscribeUrl = `${ApiPrefix}/subscription/unsubscribe?customer={0}&type={1}&emailsubscription={2}`;
export const communicationsPreferencesUrl = `${ApiPrefix}/subscription/communicationspreferences?d365Id={0}`;
export const getSubscriptions = `${ApiPrefix}/subscription/getsubscriptions?d365Id={0}`;
export const updateSubscriptionOptIn = `${ApiPrefix}/subscription/updatesubscriptionoptin?d365Id={0}`;
export const updateMembershipCardFormatPref = `${ApiPrefix}/subscription/updatemembershipcardformatpreference?d365Id={0}`;
//document downloads
export const requestCoCDocument = `${ApiPrefix}/document/requestCocDocument?policyId={0}`;
export const getDownloadCoC = `${ApiPrefix}/document/downloadCocDocument?documentId={0}`;
export const getDownloadDocument = `${ApiPrefix}/document/downloadDocument?documentId={0}`;
export const orderPhysicalCardUrl = `${ApiPrefix}/document/orderphysicalcard`;
export const getPdsOrSpdsUrl = `${ApiPrefix}/document/GetSPDSPDSLink?pdsVersion={0}`;

//login verification
export const verifyEmail = `${ApiPrefix}/account/username`;
export const sendOTP = `${ApiPrefix}/account/sendotp`;
export const verifyPasscode = `${ApiPrefix}/account/verifypasscode`;
export const resendCode = `${ApiPrefix}/account/resendotp`;
export const getIdentity = `${ApiPrefix}/account/getidentity`;
export const searchOktaAccountUrl = `${ApiPrefix}/account/searchoktaaccount`;

//username recovery
export const recoverAccountInteractionUrl = `${ApiPrefix}/account/recoveraccountinteraction?d365Id={0}&oktaId={1}`;

// registration
export const matchIdentityUrl = `${ApiPrefix}/account/matchidentity`;
export const matchAndSetIdentityUrl = `${ApiPrefix}/account/matchandsetidentity`;
export const isProvisionedUrl = `${ApiPrefix}/account/isprovisioned`;
export const setPasswordUrl = `${ApiPrefix}/account/submitpassword`;

export const changePasswordUrl = `${ApiPrefix}/account/changepassword`;
//contact us
export const getContactUsContent = `${ApiPrefix}/contactus/getcontactuscontent`;
export const contactUsSendEmail = `${ApiPrefix}/contactus/sendemail`;
